import { render, staticRenderFns } from "./CoinStore.vue?vue&type=template&id=63b492cd&scoped=true&"
import script from "./CoinStore.vue?vue&type=script&lang=ts&"
export * from "./CoinStore.vue?vue&type=script&lang=ts&"
import style0 from "./Coins.scss?vue&type=style&index=0&id=63b492cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b492cd",
  null
  
)

export default component.exports